<template>
	<v-responsive aspect-ratio="1">
		<div class="device-widget">
			<div class="status">
				<slot name="status">{{ status }}</slot>
			</div>
			<div class="sub-status">
				<slot name="sub-status">{{ subStatus }}</slot>
			</div>
			<div class="name">
				<slot name="name">{{ nodeName }}</slot>
			</div>
			<div class="room">
				<slot name="room">{{ roomName }}</slot>
			</div>
		</div>
	</v-responsive>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	props: {
		node: {
			type: Object,
			required: true,
		},
		status: {
			type: String,
			required: false,
			default: null,
		},
		subStatus: {
			type: String,
			required: false,
			default: null,
		},
		name: {
			type: String,
			required: false,
			default: null,
		},
	},

	computed: {
		...mapGetters({ nodeByGuid: "controller/nodes/nodeByGuid" }),

		parent() {
			return this.nodeByGuid(this.node.meta.parent);
		},

		nodeName() {
			return this.name;
		},

		roomName() {
			return this.parent.name;
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep .v-responsive__content {
	.device-widget {
		border-radius: 4px;
		border: 1px solid rgba(0, 0, 0, 0.2);

		width: 100%;
		height: 100%;

		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: repeat(4, 1fr);
		place-items: center stretch;

		> div {
			color: var(--v-pale-grey-darken4);
			text-align: center;
			white-space: nowrap;
			overflow: hidden;
		}

		.status {
			font-size: 1.4em;
			font-weight: bold;
			color: var(--v-pale-grey-darken3);
		}

		.sub-status {
			font-size: 0.8em;
		}

		.name {
			font-size: 1em;
		}

		.room {
			font-size: 0.8em;
		}
	}
}
</style>
